<template>
  <template v-if="node.nodeName === '#text'">
    {{ node.nodeValue }}
  </template>

  <component
    :is="node.nodeName"
    v-else
    v-bind="node.attrs"
  >
    <DpplSafeHtmlNode
      v-for="(child, index) in node.children"
      :key="index"
      :node="child"
    />
  </component>
</template>

<script setup>
defineProps({
  node: { type: Object, required: true },
});
</script>
